import { create } from "zustand";
import { v4 as uuid } from "uuid";

import { useEditorState } from "@/store";

type LogState = {
  logs: { id: string; key: string; value: any; time: number; lang: string }[];
  log: (entry: Record<string, any>, lang?: string) => void;
  clearLogs: () => void;
};

export const useLogStore = create<LogState>((set) => ({
  logs: [],
  log: (entry, lang) =>
    set((state) =>
      useEditorState.getState()?.sessionUser?.is_superuser &&
        window?.location?.search?.includes("staff")
        ? {
          logs: [
            ...state.logs,
            {
              id: uuid(),
              key: Object.keys(entry)[0],
              value: Object.values(entry)[0],
              time: Date.now(),
              lang: lang || "json",
            },
          ],
        }
        : state
    ),
  clearLogs: () => set({ logs: [] }),
}));
